export * from "./LegalText";
